import React, { useState } from 'react';
import Toggle from 'components/common/Toggle'
import CustomTickBox from 'components/common/CustomTickBox'
const WidgetOption = (props) => {
    const { widgetLabelType, setLivefeedOptionsHandle, setLivefeedGlobalOptionsHandle } = props
    const [globalWidget, setGlobalWidget] = useState(false);
    return (
        <div className="gauge-grid-item">
            <div className="editor-container">
                <div className="header grid-item">WIDGET</div>
                <span className="editor-text grid-item grid-item__title"
                    data-tip={`Option to choose the number of available units either as one figure ("50") or two ("50/75").`}
                    data-for="floorplanOptionsTooltip"
                    style={{ whiteSpace: "normal" }}>
                    Show available rooms/desks</span>
                <React.Fragment>
                    <div className="editor-text grid-item ">
                        <CustomTickBox
                            className="widget-label-setting"
                            onClick={() => {
                                /* if globalWidget is enabled, then when the widgetLabelType is modified, set globalWidget to be false*/
                                globalWidget === true && setGlobalWidget(false)
                                setLivefeedOptionsHandle(!widgetLabelType)
                            }}
                            label="Including total value ( 50/100 )"
                            isActive={widgetLabelType}
                        />
                    </div>
                    <div className="editor-text grid-item global-toggle-item">
                        <div
                            data-for="floorplanOptionsTooltip"
                            style={{ whiteSpace: "normal" }}
                            data-tip="Apply&nbsp;this&nbsp;setting&nbsp;to&nbsp;all&nbsp;slides"
                            className="global-option-toggle"
                            onClick={() => {
                                setGlobalWidget(!globalWidget);
                                setLivefeedGlobalOptionsHandle(widgetLabelType)
                            }}>
                            <div className="toggle-text">Apply to all slides</div>
                            <Toggle isActive={globalWidget} />
                        </div>
                    </div>
                </React.Fragment>
            </div>
        </div>
    );
}

export default WidgetOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/WidgetOption/index.jsx